import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { extractNumbers, MakeAxiosRequest } from "../../utils/handler";
import { phoneRegex } from "../../Constants";
import ModalBox from "../../Components/modals/ModalBox";
import FormFields from "../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../Components/SwalFns";

function NewRelationship({ showModal, closeModal, listingFn, dialogClassName }) {
  const methods = useForm();
  const { handleSubmit, reset, setValue, watch, trigger, getValues } = methods;
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [optionsList, setOptionsList] = useState({
    relations: [],
  });

  const fetchData = async () => {
    try {
      const res = await MakeAxiosRequest("post", "/getadditionalneeds");
      if(res.status=='1'){
        const relations = res.data.relations?.map((item) => ({
            id: item.id,
            name: item.relation,
        }));
        setOptionsList({ relations });
        setIsLoading(false)
      }else{
        SwalError({msg:res.message})
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  
  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  const createUser = async (data) => {
    if (isSubmitDisabled) return; // Prevent multiple submissions

    setSubmitDisabled(true);
    try {
    data.phone_number = extractNumbers(data.phone_number);
    const response = await MakeAxiosRequest("post", '/saveproxy', data);
    if (response.status == 1) {
        reset();
        closeModal();
        const responseData = {
          ...response.data?.other_relation,
          id: response.data?.other_relation.key,
          name: response.data?.other_relation.nick_name,
          optionType:'other'
        }
        listingFn && listingFn(responseData);
        if(response.data?.msg_key =='subText'){
        SwalSuccess({subText: response.data?.message, showbtn:true})
        }else{
        SwalSuccess({ msg: response.message});
        }
    } else if (response.status == 0) {
        SwalError({ msg: response.message });
    } else {
        // setError('phone_number', { type: 'custom', message: response.message });
        console.log(response.message);
    }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setSubmitDisabled(false);
    }
  };
  
  const fields = [
    {
      name: "first_name",
      label: "First Name",
      className: "col-12 mb-3",
      rules: { required: "Please enter first name" },
      type: "inputfield",
      isShow: true,
    },
    {
      name: "last_name",
      label: "Last Name",
      className: "col-12 mb-3",
      rules: { required: "Please enter last name" },
      type: "inputfield",
      isShow: true,
    },
    {
      name: "phone_number",
      countryCodeName: "country_code",
      label: "Phone Number",
      className: "col-12 mb-3",
      rules: {
        // required: "Please enter phone number",
        pattern: {
          value: phoneRegex,
          message: "Please enter a valid phone number",
        },
        validate: {
          existCheck: async (fieldValue) => {
            const response = await MakeAxiosRequest("post","/searchproxybyphone",{ phone_number: extractNumbers(fieldValue), country_code: getValues('country_code') });
            return response?.status == 1 || response?.message;
          },
        },
      },
      isdisabled: false,
      mask: "(999) 999-9999",
      type: "phonenumberfield",
      isShow: true,
    },
    {
      name: "proxy_relation_id",
      label: "This person is my :",
      className: "col-12 mb-3",
      rules: { required: "Please select relation" },
      type: "select",
      options: optionsList.relations,
      isShow: true,
    },
  ];
  
  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="md"
      hasData={!isLoading}
      dialogClassName={dialogClassName}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(createUser)}>
          <div className="text-center">
            <h3 className="modal-title">New Relationship</h3>
          </div>
          <div className="form-group mt-4">
            <div className="row">
              <FormFields fields={fields} />
            </div>
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="btn btn-primary rounded-pill w-100 p-2"
              disabled={isSubmitDisabled}
            >
              Confirm
            </button>
          </div>
        </form>
      </FormProvider>
    </ModalBox>
  );
}

export default NewRelationship;